<script lang="ts">
	import AppContainer from '../../components/AppContainer.svelte';
	import Text from '../../components/Text.svelte';
	import Button from '../../components/Button.svelte';
	import { getClient, query } from 'svelte-apollo';
	import { getLookalikeModelRowsQuery } from '../../graphql/queries/lookalike';
	import { onMount } from 'svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import SimpleTable from '../../components/SimpleTable.svelte';
	import type { LookalikeModelRow } from 'Lookalike';
	import StatusCell from '../../components/Lookalike/StatusCell.svelte';
	import { APP_PATHS } from '../../constants';
	import { Link } from 'svelte-routing';
	import ActionsCell from '../../components/Lookalike/ActionsCell.svelte';

	const client = getClient();

	const getLookalikeModelRowsOp = query(client, { query: getLookalikeModelRowsQuery });

	const columns = [
		{
			key: 'id',
			title: 'ID',
			value: (v: LookalikeModelRow) => v.id
		},
		{
			key: 'type',
			title: 'Type',
			value: (v: LookalikeModelRow) => {
				if (v.type === 'TP') {
					return 'Trackingpoint';
				} else {
					return 'DMP Segment';
				}
			},
			filterOptions: () => {
				return [
					{ name: 'Trackingpoint', value: 'TP' },
					{ name: 'DMP Segment', value: 'DMP' }
				];
			},
			filterValue: (v: LookalikeModelRow) => {
				return v.type;
			}
		},
		{
			key: 'lookalike_id',
			title: 'Trackingpoint/segment',
			value: (v: LookalikeModelRow) => {
				if (v.type == 'TP') {
					return v.targetName + " (ID " + v.targetId + ")";
				} else {
					return v.segmentName;
				}
			},
			searchValue: (v: LookalikeModelRow) => {
				if (v.type == 'TP') {
					return v.targetId;
				} else {
					return v.segmentName;
				}
			}
		},
		{
			key: 'status',
			title: 'Status',
			value: (v: LookalikeModelRow) => v.status,
			renderComponent: StatusCell,
			filterOptions: () => {
				return [
					{ name: 'SUCCESS', value: 'SUCCESS' },
					{ name: 'PENDING', value: 'PENDING' },
					{ name: 'FAILED', value: 'FAILED' }
				];
			},
			filterValue: (v: LookalikeModelRow) => {
				return v.status;
			}
		},
		{
			key: 'actions',
			title: 'Actions',
			value: (v: LookalikeModelRow) => v.id,
			renderComponent: ActionsCell
		}
	];

	const refreshFunc = () => {
		getLookalikeModelRowsOp.refetch();
	};

	onMount(() => {
		refreshFunc();
	});
</script>

<AppContainer>
	<div class="lal-model">
		<Text gutter type="headline4">Lookalike targeting overview</Text>
		<Link to={APP_PATHS.LOOKALIKE_MODEL_CREATE}>
			<Button variant="raised">Create new run</Button>
		</Link>

		<div class="table-wrapper">
			{#await $getLookalikeModelRowsOp}
				<LoadingOverlay title="Loading..." spinner />
			{:then data}
				<SimpleTable {columns} rows={data.data.lookalikeModelRows} on:refresh={refreshFunc} />
			{:catch e}
				{e}
			{/await}
		</div>
	</div>
</AppContainer>

<style lang="scss">
	.lal-model :global(.mdc-button) {
		margin-top: 15px;
	}

	.table-wrapper {
		margin-top: 30px;
	}
</style>
